/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable react/no-array-index-key */
/* eslint-disable max-classes-per-file */
import React from "react";
import Select from "react-select";
import { Input } from "reactstrap";

import TagsInput from "react-tagsinput";
import "react-tagsinput/react-tagsinput.css";
import Switch from "rc-switch";
import "rc-switch/assets/index.css";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const FormikReactSelect = ({
  name,
  value,
  options,
  isMulti,
  className,
  onChange,
  onBlur,
  maxMenuHeight,
  ref,
  styles,
  defaultValue,
  isDisabled,
}) => {
  const handleChange = (val) => {
    onChange(name, val);
  };

  const handleBlur = () => {
    onBlur(name, true);
  };

  return (
    <Select
      ref={ref}
      className={`react-select ${className}`}
      classNamePrefix="react-select"
      options={options}
      isMulti={isMulti}
      onChange={handleChange}
      defaultValue={defaultValue}
      onBlur={handleBlur}
      value={defaultValue ? defaultValue : value}
      maxMenuHeight={maxMenuHeight}
      styles={styles}
      isDisabled={isDisabled}
    />
  );
};

const FormikCheckboxGroup = ({
  name,
  value,
  options,
  inline = false,
  onChange,
  onBlur,
}) => {
  const handleChange = (val) => {
    const valueArray = [...value] || [];
    if (!valueArray.includes(val)) {
      valueArray.push(val);
    } else {
      valueArray.splice(valueArray.indexOf(val), 1);
    }
    onChange(name, valueArray);
  };

  const handleBlur = () => {
    onBlur(name, true);
  };

  return (
    <>
      {options.map((child, index) => {
        return (
          <div
            key={`${name}_${child.value}_${index}`}
            className={`position-relative form-check ${
              inline ? "form-check-inline" : ""
            }`}
          >
            <input
              name={name}
              type="checkbox"
              className="form-check-input"
              onChange={() => handleChange(child.value)}
              onBlur={handleBlur}
              defaultChecked={value.includes(child.value)}
              disabled={child.disabled}
            />
            <label className="form-check-label">{child.label}</label>
          </div>
        );
      })}
    </>
  );
};

const FormikCustomCheckboxGroup = ({
  name,
  value,
  options,
  inline = false,
  onChange,
  onBlur,
}) => {
  const handleChange = (val) => {
    const valueArray = [...value] || [];
    if (!valueArray.includes(val)) {
      valueArray.push(val);
    } else {
      valueArray.splice(valueArray.indexOf(val), 1);
    }
    onChange(name, valueArray);
  };

  const handleBlur = () => {
    onBlur(name, true);
  };

  return (
    <>
      {options.map((child, index) => {
        return (
          <Input
            key={`${name}_${child.value}_${index}`}
            id={`${name}_${child.value}_${index}`}
            type="checkbox"
            name={child.name}
            label={child.label}
            onChange={() => handleChange(child.value)}
            onBlur={handleBlur}
            checked={value.includes(child.value)}
            disabled={child.disabled}
            inline={inline}
          />
        );
      })}
    </>
  );
};

const FormikCheckbox = ({ name, value, disabled, label, onChange, onBlur }) => {
  const handleChange = (_event) => {
    onChange(name, !value);
  };
  const handleBlur = () => {
    onBlur(name, true);
  };
  return (
    <div className="position-relative form-check form-check-inline">
      <input
        name={name}
        type="checkbox"
        className="form-check-input"
        onChange={handleChange}
        onBlur={handleBlur}
        checked={value}
        disabled={disabled}
      />
      <label className="form-check-label">{label}</label>
    </div>
  );
};

const FormikCustomCheckbox = ({
  name,
  value,
  disabled,
  label,
  onChange,
  onBlur,
}) => {
  const handleChange = (_event) => {
    onChange(name, !value);
  };
  const handleBlur = () => {
    onBlur(name, true);
  };
  return (
    <Input
      type="checkbox"
      id={name}
      name={name}
      label={label}
      onChange={handleChange}
      onBlur={handleBlur}
      checked={value}
      disabled={disabled}
      inline
    />
  );
};

const FormikRadioButtonGroup = ({
  name,
  value,
  options,
  inline = false,
  onChange,
  onBlur,
}) => {
  const handleChange = (val) => {
    onChange(name, val);
  };

  const handleBlur = () => {
    onBlur(name, true);
  };

  return (
    <>
      {options.map((child, index) => {
        return (
          <div
            key={`${name}_${child.value}_${index}`}
            className={`position-relative form-check ${
              inline ? "form-check-inline" : ""
            }`}
          >
            <input
              id={child.value}
              name={name}
              type="radio"
              className="form-check-input"
              onChange={() => handleChange(child.value)}
              onBlur={handleBlur}
              defaultChecked={value === child.value}
              disabled={child.disabled}
            />
            <label className="form-check-label">{child.label}</label>
          </div>
        );
      })}
    </>
  );
};

const FormikCustomRadioGroup = ({
  name,
  value,
  options,
  inline = false,
  onChange,
  onBlur,
}) => {
  const handleChange = (val) => {
    onChange(name, val);
  };

  const handleBlur = () => {
    onBlur(name, true);
  };

  return (
    <>
      {options.map((child, index) => {
        return (
          <Input
            key={`${name}_${child.value}_${index}`}
            type="radio"
            id={`${name}_${child.value}_${index}`}
            name={child.name}
            label={child.label}
            onChange={() => handleChange(child.value)}
            onBlur={handleBlur}
            checked={value === child.value}
            disabled={child.disabled}
            inline={inline}
          />
        );
      })}
    </>
  );
};

const FormikTagsInput = ({ name, value, onChange, onBlur }) => {
  const handleChange = (val) => {
    onBlur(name, true);
    onChange(name, val);
  };

  return <TagsInput name={name} value={value} onChange={handleChange} />;
};

const FormikSwitch = ({ name, value, className, onChange, onBlur }) => {
  const handleChange = (val) => {
    onBlur(name, true);
    onChange(name, val);
  };

  return (
    <Switch
      name={name}
      className={className}
      checked={value}
      onChange={handleChange}
    />
  );
};

const FormikDatePicker = ({
  name,
  value,
  className,
  onChange,
  onBlur,
  minDate,
  styles
}) => {
  const handleChange = (val) => {
    onChange(name, val);
  };

  const handleBlur = (_val) => {
    onBlur(name, true);
  };

  return (
    <DatePicker
      dateFormat="dd-MM-yyyy"
      name={name}
      selected={value}
      onChange={handleChange}
      onBlur={handleBlur}
      minDate={minDate}
      maxDate={new Date()}
      showIcon
      showMonthDropdown
      useShortMonthInDropdown
      showYearDropdown
      autoComplete="off"
      styles={styles}
      className={className}
      scrollableYearDropdown
      yearDropdownItemNumber={200}
      dropdownMode="scroll"
    />
  );
};

const FormikMonthPicker = ({
  name,
  value,
  className,
  onChange,
  onBlur,
  minDate,
}) => {
  const handleChange = (val) => {
    onChange(name, val);
  };

  const handleBlur = (_val) => {
    onBlur(name, true);
  };

  return (
    <DatePicker
      dateFormat="MMM y"
      name={name}
      selected={value}
      onChange={handleChange}
      onBlur={handleBlur}
      maxDate={
        new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1) - 1
      }
      showIcon
      showMonthYearPicker
      autoComplete="off"
    />
  );
};

const FormikMonthPicker1 = ({
  name,
  value,
  className,
  onChange,
  onBlur,
  minDate,
}) => {
  const handleChange = (val) => {
    onChange(name, val);
  };

  const handleBlur = (_val) => {
    onBlur(name, true);
  };

  return (
    <DatePicker
      dateFormat="MMM y"
      name={name}
      selected={value}
      onChange={handleChange}
      onBlur={handleBlur}
      minDate={new Date(2023, 5, 1)}
      maxDate={
        new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1) - 1
      }
      showIcon
      showMonthYearPicker
      autoComplete="off"
    />
  );
};

const FormikDatePicker1 = ({
  name,
  value,
  className,
  onChange,
  onBlur,
  minDate,
}) => {
  const handleChange = (val) => {
    onChange(name, val);
  };

  const handleBlur = (_val) => {
    onBlur(name, true);
  };

  return (
    <DatePicker
      dateFormat="dd-MM-yyyy"
      name={name}
      className={className}
      selected={value}
      onChange={handleChange}
      onBlur={handleBlur}
      minDate={minDate}
      showMonthDropdown
      useShortMonthInDropdown
      showYearDropdown
      scrollableYearDropdown
      yearDropdownItemNumber={200}
      dropdownMode="scroll"
    />
  );
};

const FormikTripDatePicker = ({
  name,
  value,
  className,
  onChange,
  onBlur,
  minDate,
}) => {
  const handleChange = (val) => {
    onChange(name, val);
  };

  const handleBlur = (_val) => {
    onBlur(name, true);
  };

  return (
    <DatePicker
      dateFormat="dd-MM-yyyy"
      name={name}
      className={className}
      selected={value}
      onChange={handleChange}
      onBlur={handleBlur}
      minDate={minDate}
      showDisabledMonthNavigation
      placeholderText="Click to select"
      showMonthDropdown
      useShortMonthInDropdown
      showYearDropdown
      strictParsing
      scrollableYearDropdown
      yearDropdownItemNumber={200}
      dropdownMode="scroll"
    />
  );
};

const FormikPassengerDatePicker = ({
  name,
  value,
  className,
  onChange,
  onBlur,
  minDate,
  maxDate,
  validate,
  placeholderText = "Click to select",
}) => {
  const handleChange = (val) => {
    onChange(name, val);
  };

  const handleBlur = (_val) => {
    onBlur(name, true);
  };

  return (
    <DatePicker
      dateFormat="dd-MM-yyyy"
      name={name}
      className={className}
      selected={value}
      onChange={handleChange}
      onBlur={handleBlur}
      minDate={minDate}
      maxDate={maxDate}
      showDisabledMonthNavigation
      placeholderText={placeholderText}
      showMonthDropdown
      useShortMonthInDropdown
      showYearDropdown
      strictParsing
      scrollableYearDropdown
      yearDropdownItemNumber={200}
      dropdownMode="scroll"
    />
  );
};

export {
  FormikReactSelect,
  FormikCheckboxGroup,
  FormikCustomCheckboxGroup,
  FormikCheckbox,
  FormikCustomCheckbox,
  FormikRadioButtonGroup,
  FormikCustomRadioGroup,
  FormikTagsInput,
  FormikSwitch,
  FormikDatePicker,
  FormikMonthPicker,
  FormikMonthPicker1,
  FormikDatePicker1,
  FormikTripDatePicker,
  FormikPassengerDatePicker,
};
